	<!-- systemEnterpriseInformation -->
<template>
	<!-- 企业信息 -->
	<div class="systemUser">
		<div class="systemUserPC pulbic_system_oparetionBlock">
			<div class="systemUserPC-conditions">
				<div class="systemUserPC-conditions-type">
					<span>企业名称：</span>
					<input type="text" v-model="typeid" />
				</div>
			</div>
			<div class="systemUserPC-btn public_operatBtn" style="margin-left: 0px;">
				<el-button class="public_saleWater_chaxun" type="warning" icon="iconfont icon-chaxun"  @click="queryClick">查询</el-button>
			</div>
			<!-- <div class="systemUserPC-prompt-text">
				可添加用户上线：100&nbsp;已添加用户：20
			</div> -->
			<div class="systemUserPC-table">
				<div class="systemUserPC-table-li public-table-bg">
					<div class="systemUserPC-table-li-phone">厂区名称</div>
					<div class="systemUserPC-table-li-name">企业代码</div>
					<div class="systemUserPC-table-li-state">对接开通</div>
				</div>
				<div class="systemUserPC-table-li public-hover public-table-bg" v-for="(item,index) in userList" :key="index">
					<div class="systemUserPC-table-li-phone">{{item.SETTB100CA00}}</div>
					<div class="systemUserPC-table-li-name">{{item.SETTB100ID}}</div>
					
					<div class="systemUserPC-table-li-state">已开通</div>
					
				</div>
			</div>
			<div class="systemUserPC-no-text" v-if="userList.length==0">暂无数据</div>
			<div class="systemUserPC-pagesize">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				 :current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pageNum" 
				 layout="total,sizes, prev, pager, next, jumper" :total="count">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	
	export default{
		data(){
			return {
				typeid:'',
				currentPage:1,
				pageSize:1,//页数
				pageNum:10,//条数，
				count:1,//总条数,
				userList:[],
				userobj:'',
				solelist:'',
				currentUrl:this.$route.path,
				historyInfo:''
			}
		},
		created(){
			this.solelist=this.$baseAPI.querSoleList(this.$store.state.solelist,this.$route.path)
			//获取历史数据信息
			this.historyInfo=JSON.parse(sessionStorage.getItem(this.currentUrl))
			sessionStorage.removeItem(this.currentUrl)
			if(this.historyInfo!=null&&this.historyInfo!=''){
				this.init()
			}
		},
		mounted() {
			this.userobj=this.$store.state.uobj
			this.userPostList()
		},
		beforeDestroy() {
			//卸载前存储历史信息
			var obj={
				typeid:this.typeid,
				currentPage:this.currentPage,
				pageSize:this.pageSize,
				pageNum:this.pageNum
			}
			sessionStorage.setItem(this.currentUrl,JSON.stringify(obj))
		},
		methods:{
			init(){//初始化数据
				this.typeid=this.historyInfo.typeid
				this.currentPage=this.historyInfo.currentPage
				this.pageSize=this.historyInfo.pageSize
				this.pageNum=this.historyInfo.pageNum
			},
			handleSizeChange(val) {//每页多少条
				this.pageNum=val
				this.pageSize=1
				this.userPostList()
			},
			handleCurrentChange(val) {//当前页
				this.pageSize=val
				this.userPostList()
			},
			userPostList(){//查询列表
				var loading=this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var url="/set/settb100/selectPageList"
				var data={
					SETTB100CA00:this.typeid,
					page:this.pageSize,
					limit:this.pageNum,
				}
				this.axios.post(url,data).then(res=>{
					console.log(res)
					if(res.data.code==200){
						this.count=res.data.count
						this.userList=res.data.data||[]
					}
					setTimeout(()=>{
						loading.close()
					},500)
				}).catch(()=>{
					loading.close()
				})
			},
			queryClick(){//条件查询
				this.pageSize=1
				this.userPostList()
			},
			valchange(val){
				this.typeid=val
			},





			
		}
	}
</script>
<style scoped>
	.systemUserPC{
		padding: 30px 40px 40px 20px;
	}
	.systemUserPC-no-text{
		font-size: 18px;
		text-align: center;
		line-height: 80px;
		border-bottom:1px solid #CDCDCD;
	}
	.systemUserPC-conditions{
		display: flex;
		font-size: 18px;
	}
	.systemUserPC-conditions-type{
		padding-right: 30px;
		display: flex;
		flex-direction: row;
		align-items: center !important;
	}
	.systemUserPC-conditions-type>input {
		height: 40px;
		box-sizing: border-box;
		border: 1px solid #dcdfe6;
		border-radius: 5px;
		padding-left: 5px;
	}
	.systemUserPC-conditions-name input{
		display: inline-block;
		width: 240px;
		height: 40px;
		line-height: 40px;
		padding: 0 0 0 5px;
		border-radius: 5px;
		border: 1px solid #CDCDCD;
		box-sizing: border-box;
	}
	.systemUserPC-conditions-name input:focus{
		outline: none;
	}
	.systemUserPC-btn{
		padding-top: 20px;
	}
	.systemUserPC-prompt-text{
		padding-top: 15px;
		font-size: 16px;
		color: #333;
	}
	.systemUserPC-table{
		margin-top: 20px;
	}
	.systemUserPC-table-li{
		display: flex;
		text-align: center;
		height: 40px;
		line-height: 40px;
		font-size: 16px;
		color: #333;
		border-bottom:1px solid #CDCDCD;
	}
	.systemUserPC-table-li:first-child{
		font-weight: bold;
		font-size: 16px;
		height: 48px;
		line-height: 48px;
	}
	
	.systemUserPC-table-li>div{
		white-space:nowrap;
		overflow:hidden;
		text-overflow:ellipsis;
	}
	.systemUserPC-table-li-username{
		flex:.6;
	}
	.systemUserPC-table-li-role{
		flex:.6;
	}
	.systemUserPC-table-li-type{
		flex:.6;
	}
	.systemUserPC-table-li-name{
		flex:.5;
	}
	.systemUserPC-table-li-phone{
		flex:.6;
	}
	.systemUserPC-table-li-phonelogin{
		flex:.6;
	}
	.systemUserPC-table-li-actuvstate{
		flex:.5;
	}
	.systemUserPC-table-li-state{
		flex:.3;
	}
	.systemUserPC-table-li-oper{
		flex:1;
	}
	.systemUserPC-pagesize{
		margin-top: 20px;
		text-align: right;
	}
	.systemUserPC-add-user{
		padding-left: 20px;
	}
	.systemUserPC-add-user-li{
		display: flex;
		height: 42px;
		line-height: 42px;
		text-align: center;
		font-size: 16px;
		color: #333;
	}
	.systemUserPC-add-user-li>div{
		flex:1;
		border:1px solid #CDCDCD;
		border-top:none ;
	}
	.systemUserPC-add-user-li:first-child>div{
		border-top:1px solid #CDCDCD;
	}
	.systemUserPC-add-user-li>div:last-child{
		flex:.3;
		border:none;
		color: #FF4D35;
	}
	.systemUserPC-add-user-li>div:first-child{
		border-right:none;
		background: rgba(240,252,255,1);
	}
	.systemUserPC-add-user-li input{
		border: none;
		height: 100%;
		width: 100%;
		box-sizing: border-box;
		vertical-align: top;
		text-align: center;
		font-size: 16px;
	}
	.systemUserPC-add-user-btn{
		text-align: center;
		padding: 40px 0 20px 0;
	}
</style>

